<template>
  <section dir="ltr">
    <div class="movie_card" >
      <div class="info_section">
        <div class="movie_header">
          <h1>نمایشگاه در و پنجره</h1>
          <h4>تهران، ایران –  ۱۳۹۷</h4>

        </div>
        <div class="movie_desc">
          <p class="text">
            Set in a world where fantasy creatures live side by side with humans. A human cop is forced to work with an Orc to find a weapon everyone is prepared to kill for.
          </p>
        </div>
      </div>
      <div class="blur_back two_back"></div>
    </div>

    <div class="movie_card">
      <div class="info_section">
        <div class="movie_header">
          <h1>نمایشگاه ambiente</h1>
          <h4>۲۴فرانکفورت، آلمان – 2018</h4>

        </div>
        <div class="movie_desc">
          <p class="text">
            Set in a world where fantasy creatures live side by side with humans. A human cop is forced to work with an Orc to find a weapon everyone is prepared to kill for.
          </p>
        </div>
      </div>
      <div class="blur_back bright_back"></div>
    </div>

    <div class="movie_card" >
      <div class="info_section">
        <div class="movie_header">
          <h1>نمایشگاه گلس تک</h1>
          <h4>دوسلدورف، آلمان – 2018</h4>

        </div>
        <div class="movie_desc">
          <p class="text">
            Set in a world where fantasy creatures live side by side with humans. A human cop is forced to work with an Orc to find a weapon everyone is prepared to kill for.
          </p>
        </div>
      </div>
      <div class="blur_back three_back"></div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'download',
  data(){
    return{
      downloadList: [
        {
          'img': require('../../../../assets/images/news-images/DSC2165-1024x683.jpg'),
          'date': 'تهران، ایران –  ۱۳۹۷',
          'content': 'نمایشگاه در و پنجره'
        },
        {
          'img': require('../../../../assets/images/news-images/4.jpg'),
          'date': 'دوسلدورف، آلمان – 2018\n',
          'content': 'نمایشگاه گلس تک'
        },
        {
          'img': require('../../../../assets/images/news-images/4d70a297-1b24-4f47-913e-60f3ab9e4598-1.jpg'),
          'date': '۲۴فرانکفورت، آلمان – 2018',
          'content': 'نمایشگاه ambiente'
        }
      ],
    }
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat:300,400,700,800");
* {
  box-sizing: border-box;
  margin: 0;
}
html, body {
  margin: 0;
  background: white;
  font-family: "Montserrat", helvetica, arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
}
.link {
  display: block;
  text-align: center;
  color: #777;
  text-decoration: none;
  padding: 10px;
}
.movie_card {
  position: relative;
  display: block;
  width: 800px;
  height: 350px;
  margin: 80px auto;
  overflow: hidden;
  border-radius: 10px;
  transition: all 0.4s;
  box-shadow: 0px 0px 120px -25px rgba(0, 0, 0, 0.5);
}
.movie_card:hover {
  transform: scale(1.02);
  box-shadow: 0px 0px 80px -25px rgba(0, 0, 0, 0.5);
  transition: all 0.4s;
}
.movie_card .info_section {
  position: relative;
  width: 100%;
  height: 100%;
  background-blend-mode: multiply;
  z-index: 2;
  border-radius: 10px;
}
.movie_card .info_section .movie_header {
  position: relative;
  padding: 25px;
  height: 40%;
}
.movie_card .info_section .movie_header h1 {
  color: black;
  font-weight: 400;
}
.movie_card .info_section .movie_header h4 {
  color: #555;
  font-weight: 400;
}
.movie_card .info_section .movie_header .minutes {
  display: inline-block;
  margin-top: 15px;
  color: #555;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.movie_card .info_section .movie_header .type {
  display: inline-block;
  color: #959595;
  margin-left: 10px;
}
.movie_card .info_section .movie_header .locandina {
  position: relative;
  float: left;
  margin-right: 20px;
  height: 120px;
  box-shadow: 0 0 20px -10px rgba(0, 0, 0, 0.5);
}
.movie_card .info_section .movie_desc {
  padding: 25px;
  height: 50%;
}
.movie_card .info_section .movie_desc .text {
  color: #545454;
}
.movie_card .info_section .movie_social {
  height: 10%;
  padding-left: 15px;
  padding-bottom: 20px;
}
.movie_card .info_section .movie_social ul {
  list-style: none;
  padding: 0;
}
.movie_card .info_section .movie_social ul li {
  display: inline-block;
  color: rgba(0, 0, 0, 0.3);
  transition: color 0.3s;
  transition-delay: 0.15s;
  margin: 0 10px;
}
.movie_card .info_section .movie_social ul li:hover {
  transition: color 0.3s;
  color: rgba(0, 0, 0, 0.7);
}
.movie_card .info_section .movie_social ul li i {
  font-size: 19px;
  cursor: pointer;
}
.movie_card .blur_back {
  position: absolute;
  top: 0;
  z-index: 1;
  height: 100%;
  right: 0;
  background-size: cover;
  border-radius: 11px;
}
@media screen and (min-width: 768px) {
  .movie_header {
    width: 65%;
  }
  .movie_desc {
    width: 50%;
  }
  .info_section {
    background: linear-gradient(to right, #e5e6e6 50%, transparent 100%);
  }
  .blur_back {
    width: 80%;
    background-position: -100% 10% !important;
  }
}
@media screen and (max-width: 768px) {
  .movie_card {
    width: 95%;
    margin: 70px auto;
    min-height: 350px;
    height: auto;
  }
  .blur_back {
    width: 100%;
    background-position: 50% 50% !important;
  }
  .movie_header {
    width: 100%;
    margin-top: 85px;
  }
  .movie_desc {
    width: 100%;
  }
  .info_section {
    background: linear-gradient(to top, #e5e6e6 50%, transparent 100%);
    display: inline-grid;
  }
}
.bright_back {
  background: url("../../../../assets/images/news-images/DSC2165-1024x683.jpg");
}
.two_back {
  background: url("../../../../assets/images/news-images/4.jpg");
}
.three_back {
  background: url("../../../../assets/images/news-images/4d70a297-1b24-4f47-913e-60f3ab9e4598-1.jpg");
}

</style>
